import { call, put, takeLatest, all } from 'redux-saga/effects';
import { stopSubmit } from 'redux-form';

import { actions } from 'store/userReducer';
import api from 'core/utils/api';
import * as notify from 'components/ui/Notify/store/actions';
import AuthService from 'core/utils/auth/auth-service';

function* fetchUsers(action) {
  try {
    const res = yield call(api.get, '/users')
    yield put(actions.fetchUsersSuccess(res.data.users))
  } catch(err) {
    yield put(actions.fetchUsersFail(err.response.data.error))
  }
}

function* watchFetchUsers() {
  yield takeLatest(actions.fetchUsers().type, fetchUsers)
}

function* fetchUser(action) {
  try {
    const res = yield call(api.get, `/users/${action.payload}`)
    yield put(actions.fetchUserSuccess(res.data.user))
  } catch(err) {
    yield put(actions.fetchUserFail(err.response.data.error))
  }
}

function* watchFetchUser() {
  yield takeLatest(actions.fetchUser().type, fetchUser)
}

function* createUser(action) {
  try {
    yield call(api.post, '/users', {user: action.payload[0]})
    yield put(notify.actions.success('User was successfully created.'))
    yield call(action.payload[1])
  } catch(err) {
    yield put(actions.createUserFail(err.response.data.error))
    yield put(stopSubmit('user', err.response.data.error.message))
  }
}

function* watchCreateUser() {
  yield takeLatest(actions.createUser().type, createUser)
}

function* updateUser(action) {
  const user = action.payload[0]
  try {
    yield call(api.put, `/users/${user.id}`, {user})
    yield put(notify.actions.success('User was successfully updated.'))
    yield call(action.payload[1])
  } catch(err) {
    yield put(actions.updateUserFail(err.response.data.error))
    yield put(stopSubmit('user', err.response.data.error.message))
  }
}

function* watchUpdateUser() {
  yield takeLatest(actions.updateUser().type, updateUser)
}

function* deleteUser(action) {
  try {
    const res = yield call(api.delete, `/users/${action.payload}`)
    yield put(actions.deleteUserSuccess(res.data.user))
  } catch(err) {
    const { error } = err.response.data;
    yield put(actions.deleteUserFail(error))
    yield put(notify.actions.error(error.message));
  }
}

function* watchDeleteUser() {
  yield takeLatest(actions.deleteUser().type, deleteUser)
}

function* activateUser(action) {
  const { id } = action.payload[0];
  const redirect = action.payload[1];

  try {
    const res = yield call(api.patch, `/user_activations/${id}`, { user: action.payload[0] });
    AuthService.setAuthTokens(res.data.jwt, res.data.user);
    yield call(redirect);
  } catch(err) {
    yield put(stopSubmit('activateUser', { _error: err.response.data.error.message }));
  }
}

function* watchActivateUser() {
  yield takeLatest(actions.activateUser().type, activateUser);
}

function* forgotPassword(action) {
  try {
    yield call(api.post, `/password_resets`, action.payload);
    yield put(notify.actions.success('Instructions successfully sent.'));
  } catch(err) {
    yield put(stopSubmit('forgotPassword', { _error: err.response.data.error.message }));
  }
}

function* watchForgotPassword() {
  yield takeLatest(actions.forgotPassword().type, forgotPassword);
}

function* resetPassword(action) {
  const { id } = action.payload[0];
  const redirect = action.payload[1];

  try {
    yield call(api.patch, `/password_resets/${id}`, { user: action.payload[0] });
    yield put(notify.actions.success('Password successfully reset.'));
    yield call(redirect);
  } catch(err) {
    yield put(stopSubmit('resetPassword', { _error: err.response.data.error.message }));
  }
}

function* watchResetPassword() {
  yield takeLatest(actions.resetPassword().type, resetPassword);
}

export default function* usersSaga() {
  yield all([
    watchFetchUsers(),
    watchFetchUser(),
    watchCreateUser(),
    watchUpdateUser(),
    watchDeleteUser(),
    watchActivateUser(),
    watchForgotPassword(),
    watchResetPassword(),
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/usersSaga.js